import { AuditLogStreamState, AuditLogStreamStatus } from '@/api/generated/api'

export const isStreamUnhealthy = (logStream: AuditLogStreamStatus | null | undefined): boolean =>
  logStream?.state === AuditLogStreamState.Error || logStream?.state === AuditLogStreamState.Invalid

const DEFAULT_CHECKS = ['Check that the credentials and endpoint are still valid.']

const CHECKS_BY_DESTINATION: Record<string, string[]> = {
  S3: [
    'Check the bucket policy for Deny statements on s3:PutObject, such as encryption or prefix rules.',
    'Check that the role trust policy and any KMS key allow WorkOS.',
  ],
}

export const checksForDestination = (type: string): string[] => CHECKS_BY_DESTINATION[type] ?? DEFAULT_CHECKS

const DESTINATION_LABELS: Record<string, string> = {
  AzureSentinel: 'Azure Sentinel',
  GenericHttps: 'your HTTPS endpoint',
  GoogleCloudStorage: 'Google Cloud Storage',
}

export const destinationLabel = (type: string): string => DESTINATION_LABELS[type] ?? type
